import AngleRightIcon from 'assets/svgs/AngleRightIcon';
import React from 'react';

import './index.styles.scss';

interface Props {
  show: boolean;
  posX: number;
  posY: number;
  onClose: () => void;
  onSelected: (action: 'personal' | 'persona') => void;
}

export const MobileCloneTopFilterModal = ({
  show,
  posX,
  posY,
  onClose,
  onSelected
}: Props) => {
  if (show) {
    return (
      <div
        className="mobile_clone_top_filter_modal"
        id="mobile_clone_top_filter_modal"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <div
          className="question_filter_action_modal_body"
          style={{ left: posX, top: posY, position: 'fixed' }}
        >
          <div
            className="action_item row_align_items clickable"
            onClick={(e) => {
              e.stopPropagation();
              onSelected('personal');
            }}
          >
            <div className="action_name font-medium font16">Personal AI</div>
            <div style={{ marginLeft: 6 }}>
              <AngleRightIcon color={'#FF3E9A'} opacity={1} />
            </div>
          </div>
          <div
            className="action_item row_align_items clickable"
            onClick={(e) => {
              e.stopPropagation();
              onSelected('persona');
            }}
          >
            <div className="action_name font-medium font16">Personas</div>
            <div style={{ marginLeft: 6 }}>
              <AngleRightIcon color={'#FF3E9A'} opacity={1} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};
